export default __webpack_public_path__ + "static/media/ico_clinic.fc7112cc.svg";